/**
 *
 * Jira
 *
 */

import React from 'react';

import { Clients } from '@ariksa/notification';
import { ClientsApiAddClientRequest } from '@ariksa/notification/api';
import { useDispatch } from 'react-redux';

import { actions } from '../../../../slice';

import { ServiceNowForm } from './ServiceNowForm';

interface Props {
  onSubmit: (data) => void;
  setValidate: (value: boolean) => void;
  validate: boolean;
}

export const CreateServicenow = (props: Props) => {
  const { validate, setValidate, onSubmit } = props;
  const dispatch = useDispatch();

  const createClient = data => {
    const {
      client_secret,
      instance,
      instance_password,
      client_id,
      user,
      name,
    } = data;
    const payload: ClientsApiAddClientRequest = {
      clientConfig: {
        client_name: Clients.Servicenow,
        status: true,
        name,
        service_now: {
          user,
          client_id,
          client_secret,
          instance,
          instance_password,
        },
      },
    };
    dispatch(
      actions.createClient({
        q: payload,
        onSuccess: res => {
          setValidate(true);
          dispatch(actions.updateActiveClient(res));
        },
      }),
    );
  };

  const handleSubmit = data => {
    validate ? onSubmit(data) : createClient(data);
  };

  return <ServiceNowForm handleSubmit={handleSubmit} validate={validate} />;
};
